import { render, staticRenderFns } from "./OverviewDetails.vue?vue&type=template&id=38efb97c"
import script from "./OverviewDetails.vue?vue&type=script&lang=js"
export * from "./OverviewDetails.vue?vue&type=script&lang=js"
import style0 from "./OverviewDetails.vue?vue&type=style&index=0&id=38efb97c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports